import {Cloneable} from "@/common/Cloneable";
import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {ProductTrackItemModel} from "@/modules/redactor/models/product/ProductTrackItemModel";

export class ProductTrackModel extends Cloneable {

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(ProductTrackModel, v) : SKIP;
        }, (v) => {
            return deserialize(ProductTrackModel, v);
        });
    }

    constructor() {
        super();
        this._products = [];
    }

    get products() {
        return this._products;
    }

    set products(value) {
        this._products = value;
    }

    empty() {
        return !this.products || this.products.length == 0;
    }

    valid() {

        if (this.products && this.products.some(v => !v || !v.valid() || v.empty())) {
            return false;
        }

        return !this.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ProductTrackModel());
        } else if (target instanceof ProductTrackModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ProductTrackModel, {
    _products: alias("products", list(ProductTrackItemModel.schema())),
})